import { StarRating } from '@yes.technology/react-toolkit'
import { ActivityModel } from 'types/shared'
import { ActivityInputProps } from '../Activity.types'

type ActivityStarsEvaluationProps = {
  value: ActivityModel['value']
  onChange: ActivityInputProps['handleChange']
} & Pick<
  React.ComponentProps<typeof StarRating>,
  'des' | 'complement' | 'nStars' | 'disabled' | 'informational'
>

const ActivityStarsEvaluation = ({
  value,
  onChange,
  ...props
}: ActivityStarsEvaluationProps) => {
  const handleChange = (starSelected: number) => {
    onChange(`${starSelected}`)
  }

  return (
    <StarRating
      heightClass='regular'
      onChange={handleChange}
      starSelected={Number(value) || 0}
      {...props}
    />
  )
}

export default ActivityStarsEvaluation
